import { Component, OnInit, OnDestroy } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs/internal/observable/empty';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-catalogs-catalog-dashboard',
  templateUrl: './catalogs-catalog-dashboard.component.html',
  styleUrls: ['./catalogs-catalog-dashboard.component.scss']
})
export class CatalogsCatalogDashboardComponent implements OnInit, OnDestroy {

  catalog;
  centers;
  desks;
  mCatalogDevices;
  staffDevices;
  getCatalogInfoSubscription: Subscription;
  refreshCatalogSubscription: Subscription;
  getCatalogDesksSubscription: Subscription;
  getCatalogDevicesMCatalogSubscription: Subscription;
  getCatalogDevicesStaffSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.centers = this.userStorageService.getCenterList();
    this.setBreadcrumb();
    this.getCatalogInfo();
    this.refreshCatalogSubscription = this.catalogsService.refreshCatalogListen().subscribe(
      (res) => {
        this.getCatalogInfo();
      }
    );
  }

  public getCatalogInfo() {
    const internalId = this.activatedRoute.snapshot.params['catalogid'];
    this.getCatalogInfoSubscription = this.catalogsService.getCatalogInfo(internalId).pipe(
      tap(o => this.catalog = o),
      tap(o => this.catalog.Centers.length > 0 ? this.getCatalogDesks(this.getCenterInternalIds(this.catalog.Centers)) : this.desks = [] ),
      tap(o => this.catalog.Centers.length > 0 ? this.getCatalogDevicesMCatalog(this.getCenterInternalIds(this.catalog.Centers)) : this.mCatalogDevices = []),
      tap(o => this.catalog.Centers.length > 0 ? this.getCatalogDevicesStaff(this.getCenterInternalIds(this.catalog.Centers)) : this.staffDevices = []),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  public getCatalogDesks(centerInternalIds) {
    this.getCatalogDesksSubscription = this.catalogsService.getCatalogDesks(centerInternalIds).pipe(
      tap(o => this.desks = o)
    ).subscribe();
  }

  public getCatalogDevicesMCatalog(centerInternalIds) {
    this.getCatalogDevicesMCatalogSubscription = this.catalogsService.getCatalogDevicesMCatalog(centerInternalIds).pipe(
      tap(o => this.mCatalogDevices = o)
    ).subscribe();
  }

  public getCatalogDevicesStaff(centerInternalIds) {
    this.getCatalogDevicesStaffSubscription = this.catalogsService.getCatalogDevicesStaff(centerInternalIds).pipe(
      tap(o => this.staffDevices = o)
    ).subscribe();
  }

  private getCenterInternalIds(centers) {
    if (centers) {
      return centers.map(c => c.InternalId);
    }
    return [];
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-book', 'catalogs-page.catalog detail', '/catalog/catalogs', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.catalogs', '/catalog/catalogs'), new BRoute('catalogs-page.catalog detail')]));
  }

  ngOnDestroy() {
    if (this.getCatalogInfoSubscription) { this.getCatalogInfoSubscription.unsubscribe(); }
    if (this.refreshCatalogSubscription) { this.refreshCatalogSubscription.unsubscribe(); }
    if (this.getCatalogDesksSubscription) { this.getCatalogDesksSubscription.unsubscribe(); }
    if (this.getCatalogDevicesMCatalogSubscription) { this.getCatalogDevicesMCatalogSubscription.unsubscribe(); }
    if (this.getCatalogDevicesStaffSubscription) { this.getCatalogDevicesStaffSubscription.unsubscribe(); }
  }

}
